/**
 * Module dependencies.
 */

import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';
import { cn } from 'app/lib/utils';

/**
 * Export `Popover` component.
 */

const Popover = PopoverPrimitive.Root;

/**
 * Export `PopoverTrigger` component.
 */

const PopoverTrigger = PopoverPrimitive.Trigger;

/**
 * Export `PopoverAnchor` component.
 */

const PopoverAnchor = PopoverPrimitive.Anchor;

/**
 * Export `PopoverContent` component.
 */

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      align={align}
      className={cn(
        'z-50 w-72 rounded-md border border-border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className
      )}
      ref={ref}
      sideOffset={sideOffset}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

/**
 * Exports.
 */

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger };
